module.exports = __webpack_public_path__ + "img/spend_bitacora.dd8780a2.png";